import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';

export function useIsFreeOrStandardUser() {
	const { edition } = useSessionData();

	return edition === ConfluenceEdition.FREE || edition === ConfluenceEdition.STANDARD;
}
